__webpack_require__.p = "https://prachay.moneykart.in/";